import { Button } from "@/components/ui/button";
import { Download, Copy } from "lucide-react";
import { toast } from "sonner";

export const RecoveryCodes = ({ codes, email, onDone }) => {
  const text = `Recovery codes for ${email}\nGenerated ${new Date().toLocaleString("en-GB")}\nEach code can be used once. Keep them somewhere safe.\n\n${codes.join("\n")}\n`;
  const download = () => {
    const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
    const a = Object.assign(document.createElement("a"), { href: url, download: "recovery-codes.txt" });
    a.click(); URL.revokeObjectURL(url);
  };
  const copy = async () => { await navigator.clipboard.writeText(codes.join("\n")); toast.success("Codes copied"); };

  return (
    <div className="space-y-3" data-testid="mfa-recovery-codes">
      <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-3">
        Save these recovery codes now. They will not be shown again. Each one gets you in once if you lose your phone.
      </p>
      <div className="grid grid-cols-2 gap-2 rounded-md bg-slate-900 p-4 font-mono text-sm text-slate-100">
        {codes.map((c) => <span key={c} data-testid="mfa-recovery-code">{c}</span>)}
      </div>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={download} className="gap-1" data-testid="mfa-download-codes-btn"><Download size={14} /> Download .txt</Button>
        <Button size="sm" variant="outline" onClick={copy} className="gap-1" data-testid="mfa-copy-codes-btn"><Copy size={14} /> Copy</Button>
        <Button size="sm" variant="ghost" onClick={onDone} data-testid="mfa-codes-done-btn">I've saved them</Button>
      </div>
    </div>
  );
};
